function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 20.5C0 9.1754 9.1754 0 20.5 0C31.8246 0 41 9.1754 41 20.5C41 31.8246 31.8246 41 20.5 41C9.1754 41 0 31.8246 0 20.5ZM20.5 37.0323C11.366 37.0323 3.96777 29.6341 3.96777 20.5C3.96777 11.366 11.366 3.96777 20.5 3.96777C29.6341 3.96777 37.0323 11.366 37.0323 20.5C37.0323 29.6341 29.6341 37.0323 20.5 37.0323ZM18.5906 23.3023L25.6085 28.4025C26.0549 28.7249 26.6749 28.6257 26.9972 28.1876L28.5513 26.0466C28.8736 25.6003 28.7827 24.9803 28.3364 24.6579L22.8146 20.6406L22.8146 8.92748C22.8146 8.38192 22.3682 7.93555 21.8226 7.93555L19.1775 7.93555C18.6319 7.93555 18.1855 8.38192 18.1855 8.92748L18.1855 22.5005C18.1855 22.8146 18.3343 23.1122 18.5906 23.3023Z",
  id: "Shape",
  fill: "#0080FF",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.771f2803.svg";
export { ForwardRef as ReactComponent };